import api from "@/services/vex/api";
import { serializeError } from "serialize-error";

async function logger(error, info = null) {
    try {
        const uri = "/logs/v1/log/insert";
        let data = {
            origem: "VEXWEB",
            error: serializeError(error),
        };

        if(info != null) {
            data.info = info;
        }

        api.post(uri, data).catch((err) => console.error(err));
    } catch (err) {
        err.message = "Erro ao enviar log:" + err.message;
        console.error(err);
    }
}

export default logger;